import { render } from "./WirtschaftlichkeitConfig.vue?vue&type=template&id=4faab162"
import script from "./WirtschaftlichkeitConfig.vue?vue&type=script&lang=js"
export * from "./WirtschaftlichkeitConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__